module.exports = __webpack_public_path__ + "static/media/person-dolly.40194c59.svg";